import { addToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { GenerateCuratedThreadsFulfilledAction } from '../../domains/curatedThreadList/actions.types';

import type { CuratedThreadListIdMap } from './types';

const initialState: CuratedThreadListIdMap = {};

const reducer: Reducer<CuratedThreadListIdMap, GenerateCuratedThreadsFulfilledAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'GENERATE_CURATED_THREADS.FULFILLED': {
      const { fileId, groupId, curatedThreadListId } = action.payload;

      return addToRecord(state, fileId, {
        id: fileId,
        groupId,
        curatedThreadListId,
      });
    }
    default:
      return state;
  }
};

export default reducer;
